import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-loading-spinner',
  imports: [],
  template: `
    <div style="display: flex; align-items: center; justify-content: center; padding: 2rem;">
      <div class="loading-spinner"></div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Default,
  styles: [`
    .loading-spinner {
      border: 3px solid #f3f3f3;
      border-top: 3px solid var(--primary-color, #93F64E);
      border-radius: 50%;
      width: 40px;
      height: 40px;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `]
})
export class LoadingSpinnerComponent {}
